<template>
    <div>
        <div class="item-titlebox">
            <div class="item-titlebox-left">
                {{ processorName }}
            </div>
        </div>

        <el-form-item v-if="visible && selection">
            <div slot="label" class="input-form-setting">{{processor.title}}</div>
            <el-select v-if="disabled(processor)" disabled :placeholder="nameOfSelectedValue(processor)"></el-select>
            <el-select v-else style="margin-left:15px" v-model="processor.value">
                <el-option v-for="(candidate, index) in processor.candidates" :key="candidate.name" :label="candidate.name" :value="index"></el-option>
            </el-select>
        </el-form-item>

        <div v-for="parameter in processor.parameters" :key="parameter.jsonkey">
            <DefinitionParameterInput
                v-if="findCommand(parameter, 'selectStorageFolder')"
                :ref="parameter.jsonKey"
                :parameter="parameter"
                :dependParameter="'keyVaultId'"
                :isNew="isNew"
                @update:valid = "updateValid(parameter, $event)"
            />

            <DefinitionParameterUserSelection
                v-else-if="findCommand(parameter, 'selectUser')"
                :ref="parameter.jsonKey"
                :parameter="parameter"
                :addCase="true"
                @update="syncValue"
                @update:valid = "updateValid(parameter, $event)"
            />

            <DefinitionParameterInput
                v-else
                :ref="parameter.jsonKey"
                :parameter="parameter"
                :isNew="isNew"
                @update="syncValue"
                @update:valid = "updateValid(parameter, $event)"
            />
        </div>
    </div>
</template>

<script>
import processorTemplateUtil from "@/components/pc/setting/ai-app/AiAppSettingUtil";
import DefinitionParameterInput from "@/components/pc/setting/ai-app/DefinitionParameterInput";
import DefinitionParameterUserSelection from "@/components/pc/setting/ai-app/DefinitionParameterUserSelection";

export default {
    components: { DefinitionParameterInput, DefinitionParameterUserSelection },

    model: {
        prop: 'processor'
    },

    props: {
        processor: {
            type: Object,
            required: true
        },
        isNew: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            valid: false,
            validMap: new Map()
        }
    },

    computed: {
        visible() {
            return processorTemplateUtil.judgeVisible(this.processor);
        },
        selection() {
            return processorTemplateUtil.needSelection(this.processor);
        },
        disabled() {
            return processorTemplateUtil.judgeDisabled(this.processor);
        },
        processorName() {
            return processorTemplateUtil.getLocaledText(this.$i18n, this.processor.name);
        },
        nameOfSelectedValue() {
            return processorTemplateUtil.getNameOfSelectedValue(this.$i18n, this.processor);
        },
    },

    created() {
        this.valid = false
        for (let parameter of this.processor.parameters) {
            this.validMap.set(parameter.jsonKey, false)
        }
    },

    methods: {
        updateValid(parameter, valid) {
            this.validMap.set(parameter.jsonKey, valid)

            let newValidStatus = true;
            for (let value of this.validMap.values()) {
                newValidStatus = newValidStatus && value
            }

            if (this.valid !== newValidStatus) {
                this.valid = newValidStatus
                this.$emit('update:valid', newValidStatus)
            }
        },
        syncValue(jsonKey, value) {
            for (let key in this.$refs) {
                if (!Array.isArray(this.$refs[key]) || this.$refs[key].length === 0) {
                    continue
                }

                let dependParameter = this.$refs[key][0].getDependParameter()
                if (jsonKey === dependParameter) {
                    this.$refs[key][0].onChangeDependParameter(value)
                }
            }
        },
        findCommand(parameter, command) {
            return processorTemplateUtil.findCommand(parameter, command);
        }
    }

}
</script>

<style scoped>

.item-titlebox {
    width: 100%;
    background-color: #f6f6f6;
    display: table;
    border-bottom: 1px #fff solid;
    margin-bottom: 10px;
}
.item-titlebox-left {
    padding: 10px 0 10px 15px;
    width: 50%;
    display: table-cell;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}

.el-form-item {
    margin-left: 100px
}

</style>
